<template>
    <div class="bar" :style="barValue">
        <div class="bar-info">
            {{ formattedDate }}
        </div>
    </div>
</template>

<script>
import { getPastPartByPercent } from "./helpers";

export default {
    name: "ProgressBar",

    props: {
        startDate: {
            type: Object,
            default: null,
        },

        endDate: {
            type: Object,
            default: null,
        },
    },

    computed: {
        value() {
            const start = this.startDate;
            const end = this.endDate;
            return getPastPartByPercent(start, end);
        },

        barValue() {
            return {
                background: `linear-gradient(to right, #D1004A ${ this.value }%, #D2D5D9 ${ this.value }%)`,
            };
        },

        formattedDate() {
            return this.endDate ? this.endDate.format('DD MMMM, YYYY') : '';
        },
    },
};
</script>

<style lang="scss" scoped>
.bar {
    width: 100%;
    height: 12px;
    background-color: #D2D5D9;

    &-info {
        margin-right: 8px;
        font-weight: 600;
        font-size: 10px;
        line-height: 12px;
        text-align: right;
        color: #FFFFFF;
    }
}
</style>